module.exports = __webpack_public_path__ + "img/lifting4.ac69a875.png";